import * as React from 'react';
import {
  Create,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  SaveButton,
  TopToolbar,
} from 'react-admin';
import { codesFields, CodeTypeChoices } from '../codes.model';
import { orgsFields } from '../../organizations/orgs.model';
import { ALL_ORGANIZATIONS_RESOURCE_NAME as ORGANIZATIONS_RESOURCE } from '../../organizations/organizations.dataProvider';
import ProviderRoleOrderedList from '../../components/ProviderRoleOrderedList';
import {
  validateCodeName,
  validateOrganization,
  validateCodeType,
} from './utils/codeValidators';
import CodeInput from './fields/CodeInput.component';
import { useCreateWithRefresh } from '../../hooks/useMutationWithRefresh';
import { ORGANIZATION_DROPDOWN_PERPAGE } from '../../utils/constants';
import { SectionedForm } from '../../components/layouts';

const CodeCreate = () => {
  const mutationOptions = useCreateWithRefresh('codes', {
    successMessage: 'Code created successfully',
  });

  const sections = [
    {
      title: "Code Details",
      fields: [
        <CodeInput
          key="codeName"
          source={codesFields.codeName}
          label="Code Name"
          validate={validateCodeName}
          autoFocus
        />,
        <ReferenceInput
          key="organization"
          source={codesFields.orgId}
          reference={ORGANIZATIONS_RESOURCE}
          label="Organization"
          perPage={ORGANIZATION_DROPDOWN_PERPAGE}
          sort={{ field: 'name', order: 'ASC' }}
        >
          <AutocompleteInput
            optionText={orgsFields.orgName}
            validate={validateOrganization}
          />
        </ReferenceInput>,
        <SelectInput
          key="codeType"
          label="Code Type"
          source={codesFields.codeType}
          choices={CodeTypeChoices}
          validate={validateCodeType}
        />
      ]
    },
    {
      title: "Configuration",
      fields: [
        <ProviderRoleOrderedList key="providerRoles" rolesFieldName={codesFields.roleIds} />
      ]
    }
  ];

  return (
    <Create
      title="Create Membership Code"
      mutationOptions={mutationOptions}
    >
      <SectionedForm 
        sections={sections}
        mode="onBlur"
        warnWhenUnsavedChanges
        toolbar={
          <TopToolbar>
            <SaveButton label="Create Code" sx={{ marginLeft: 2 }} />
          </TopToolbar>
        }
      />
    </Create>
  );
};

export default CodeCreate;
